import { GeoConfigType } from '../../core/chart-ui-utils';
import { createLogger } from '../../utils/logger';
import { Countries } from './countries';
import { getGeoConfig, } from './geo-country-config-data';
import { getGeoDefaultCountryConfig } from './geo-country-default-config';
class GeoCountryConfig {
    static get(countryCode) {
        if (!GeoCountryConfig.configByCountry[countryCode]) {
            GeoCountryConfig.configByCountry[countryCode] = new GeoCountryConfig(countryCode);
        }
        return GeoCountryConfig.configByCountry[countryCode];
    }
    getCountryCode() {
        return this.countryCode;
    }
    isZipSupported() {
        return (this.config.SUPPORT.ZIP || getGeoDefaultCountryConfig().SUPPORT.ZIP);
    }
    isDiv1Supported() {
        return (this.config.SUPPORT.DIV_1 ||
            getGeoDefaultCountryConfig().SUPPORT.DIV_1);
    }
    isDiv2Supported() {
        return (this.config.SUPPORT.DIV_2 ||
            getGeoDefaultCountryConfig().SUPPORT.DIV_2);
    }
    isLevelSupported(geoConfigType) {
        switch (geoConfigType) {
            case GeoConfigType.ADMIN_DIV_1:
                return this.isDiv1Supported();
            case GeoConfigType.ADMIN_DIV_2:
                return this.isDiv2Supported();
            case GeoConfigType.ZIP_CODE:
                return this.isZipSupported();
            default:
                this.logger.error('Invalid level passed', geoConfigType);
                return false;
        }
    }
    getZipNormalizer() {
        return ((this.config.NORMALIZER && this.config.NORMALIZER.ZIP) ||
            getGeoDefaultCountryConfig().NORMALIZER.ZIP);
    }
    getDiv1Normalizer() {
        return ((this.config.NORMALIZER && this.config.NORMALIZER.DIV_1) ||
            getGeoDefaultCountryConfig().NORMALIZER.DIV_1);
    }
    getDiv2Normalizer() {
        return ((this.config.NORMALIZER && this.config.NORMALIZER.DIV_2) ||
            getGeoDefaultCountryConfig().NORMALIZER.DIV_2);
    }
    getNormalizer(geoConfigType) {
        switch (geoConfigType) {
            case GeoConfigType.ADMIN_DIV_1:
                return this.getDiv1Normalizer();
            case GeoConfigType.ADMIN_DIV_2:
                return this.getDiv2Normalizer();
            case GeoConfigType.ZIP_CODE:
                return this.getZipNormalizer();
            default:
                this.logger.error('Invalid level passed', geoConfigType);
        }
        return undefined;
    }
    getZipLabel(getTranslatedText) {
        return ((this.config.LABEL && this.config.LABEL.ZIP) ||
            getTranslatedText(getGeoDefaultCountryConfig().LABEL.ZIP));
    }
    getDiv1Label(getTranslatedText) {
        return ((this.config.LABEL && this.config.LABEL.DIV_1) ||
            getTranslatedText(getGeoDefaultCountryConfig().LABEL.DIV_1));
    }
    getDiv2Label(getTranslatedText) {
        return ((this.config.LABEL && this.config.LABEL.DIV_2) ||
            getTranslatedText(getGeoDefaultCountryConfig().LABEL.DIV_2));
    }
    getLabel(geoConfigType, getTranslatedText) {
        switch (geoConfigType) {
            case GeoConfigType.ADMIN_DIV_1:
                return this.getDiv1Label(getTranslatedText);
            case GeoConfigType.ADMIN_DIV_2:
                return this.getDiv2Label(getTranslatedText);
            case GeoConfigType.ZIP_CODE:
                return this.getZipLabel(getTranslatedText);
            default:
                this.logger.error('Invalid level passed', geoConfigType);
        }
        return undefined;
    }
    getExtraFieldsToMatch(geoConfigType) {
        switch (geoConfigType) {
            case GeoConfigType.ADMIN_DIV_1:
                return ((this.config.EXTRA_FIELDS &&
                    this.config.EXTRA_FIELDS.DIV_1) ||
                    getGeoDefaultCountryConfig().EXTRA_FIELDS.DIV_1);
            case GeoConfigType.ADMIN_DIV_2:
                return ((this.config.EXTRA_FIELDS &&
                    this.config.EXTRA_FIELDS.DIV_2) ||
                    getGeoDefaultCountryConfig().EXTRA_FIELDS.DIV_2);
            default:
                throw new Error(`Invalid geoConfigType passed: ${geoConfigType}`);
        }
    }
    constructor(countryCode) {
        this.countryCode = countryCode;
        this.supportedCountries = Object.keys(getGeoConfig()).map(isoCode => {
            return Countries[isoCode];
        });
        this.logger = createLogger('GeoCountryConfig');
        const geoConfig = getGeoConfig();
        if (!geoConfig[countryCode]) {
            this.logger.info('No specific configuration exists for ', countryCode);
            this.config = { SUPPORT: {} };
        }
        else {
            this.config = geoConfig[countryCode];
        }
    }
}
GeoCountryConfig.configByCountry = {};
export default GeoCountryConfig;
//# sourceMappingURL=geo-country-config.js.map